
import React from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

const AnalyticsSkeletons: React.FC = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
    <Card>
      <CardHeader className="pb-2">
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-4 w-48 mt-1" />
      </CardHeader>
      <CardContent className="pt-0">
        <Skeleton className="h-64 w-full" />
      </CardContent>
    </Card>
    <Card>
      <CardHeader className="pb-2">
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-4 w-48 mt-1" />
      </CardHeader>
      <CardContent className="pt-0">
        <Skeleton className="h-64 w-full" />
      </CardContent>
    </Card>
  </div>
);

export default AnalyticsSkeletons;
